// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__hR6tq","page-content":"Pagination_page-content__Kklun"};